export default "__VITE_ASSET__CMEyRksy__"